import { render, staticRenderFns } from "./DefinitiveList.vue?vue&type=template&id=60e676d0&"
import script from "./DefinitiveList.vue?vue&type=script&lang=js&"
export * from "./DefinitiveList.vue?vue&type=script&lang=js&"
import style0 from "./DefinitiveList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports